// 引入axios 实例
import request from '@/utils/request'
import qs from 'qs'
//省级大屏基本数据
export const provinceLargeScreenOverview = (data) => {
    return request({
        url: '/api/provinceLargeScreen/overview',
        method: 'post',
        params:data
    })
}
//省级大屏总日志量
export const provinceLargeScreenGetLogAllNum = (data) => {
    return request({
        url: '/api/provinceLargeScreen/getLogAllNum',
        method: 'post',
        params:data
    })
}
//用户活跃情况
export const provinceLargeScreengetUserActiveDetail = (data) => {
    return request({
        url: '/api/provinceLargeScreen/getUserActiveDetail',
        method: 'post',
        params:data
    })
}
//实时动态
export const provinceLargeScreengetTodayActiveCourse = (data) => {
    return request({
        url: '/api/provinceLargeScreen/getTodayActiveCourse',
        method: 'post',
        params:data
    })
}
//数据增长曲线图
export const provinceLargeScreengetDataGrowthCurve = (data) => {
    return request({
        url: '/api/provinceLargeScreen/getDataGrowthCurve',
        method: 'post',
        params:data
    })
}

